export default __webpack_public_path__ + "static/media/waave_green.75948308.png";